import React, { useEffect, useState } from "react";
import { Row, Col } from "reactstrap";
import api from "../../api";
import AnnouncementCard from "./AnnouncementCard";
import ImportantDatesCard from "./ImportantDatesCard";
import NewsCard from "./NewsCard";
import EventCard from "./EventCard";

const DashboardUpdates = ({ role }) => {
    const [updates, setUpdates] = useState({});



    useEffect(() => {
        loadData();
    }, []);

    const loadData = async () => {
        const response = await api.get("/updates");
        const grouped = {};
        response.data.forEach((g) => {
            grouped[g.type] = g.items;
        });
        setUpdates(grouped);
    };

    return (
        <Row className="mt-4">
            <Col lg="3">
                <AnnouncementCard data={updates.Announcement || []} role={role} refresh={loadData} />
            </Col>
            <Col lg="3">
                <ImportantDatesCard data={updates.ImportantDate || []} role={role} refresh={loadData} />
            </Col>
            <Col lg="3">
                <NewsCard data={updates.News || []} role={role} refresh={loadData} />
            </Col>
            <Col lg="3">
                <EventCard data={updates.Event || []} role={role} refresh={loadData} />
            </Col>

        </Row>
    );
};

export default DashboardUpdates;
